import { useState, memo, useMemo, useCallback } from 'react';

import { IReportItem } from 'APIPackage/MainModule/interfaces/IReportItem';
import { TableColumnSortEnum } from 'CorePackage/MainModule/enums/TableColumnSortEnum';

import styles from './ReportTable.module.scss';
import { ReportItem } from './ReportItem';

export interface IReportTableProps {
  items: IReportItem[];
  onItemClick: (id: IReportItem['type']) => void;
}

export const ReportTable = memo(({ items, onItemClick }: IReportTableProps) => {
  const [sortDirection, setSortDirection] = useState<TableColumnSortEnum>(TableColumnSortEnum.NONE);

  const handleListTitleClick = useCallback(() => {
    setSortDirection(prevDirection => {
      let newSort = TableColumnSortEnum.NONE;

      if (prevDirection === TableColumnSortEnum.NONE) {
        newSort = TableColumnSortEnum.ASC;
      } else if (prevDirection === TableColumnSortEnum.ASC) {
        newSort = TableColumnSortEnum.DESC;
      }

      return newSort;
    });
  }, []);

  const sortIcon = useMemo(() => {
    switch (sortDirection) {
      case 'asc':
        return '\xa0↑';
      case 'desc':
        return '\xa0↓';
      case '':
      default:
        return null;
    }
  }, [sortDirection]);

  const currentItems = useMemo(() => {
    if (sortDirection === 'asc') {
      return [...items].sort((itemA: IReportItem, itemB: IReportItem) => itemA.name.localeCompare(itemB.name));
    }
    if (sortDirection === 'desc') {
      return [...items].sort((itemA: IReportItem, itemB: IReportItem) => itemB.name.localeCompare(itemA.name));
    }

    return items;
  }, [items, sortDirection]);

  return (
    <div className={styles.Block}>
      <h2 className={styles.Title}>Выбор отчета</h2>
      <div className={styles.List}>
        <div className={styles.ListTitle}>
          <span className={styles.ListTitleText} onClick={handleListTitleClick}>
            Отчет
            {sortIcon}
          </span>
        </div>
        {currentItems.map(item => (
          <ReportItem key={item.type} item={item} onItemClick={onItemClick} />
        ))}
      </div>
    </div>
  );
});
